import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.t("messengerChannelPicker.header")), 1),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.buttonClasses),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectChannel(_ctx.ConversationChannel.Website)), ["prevent"]))
    }, _toDisplayString(_ctx.t("messengerChannelPicker.rightHereOption")), 3),
    (_ctx.offerWhatsapp)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.secondaryButtonClasses),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectChannel(_ctx.ConversationChannel.WhatsApp)), ["prevent"]))
        }, " WhatsApp ", 2))
      : _createCommentVNode("", true),
    (_ctx.offerSms)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.secondaryButtonClasses),
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectChannel(_ctx.ConversationChannel.Sms)), ["prevent"]))
        }, " SMS ", 2))
      : _createCommentVNode("", true),
    (_ctx.offerEmail)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(_ctx.secondaryButtonClasses),
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.selectChannel(_ctx.ConversationChannel.Email)), ["prevent"]))
        }, _toDisplayString(_ctx.t("messengerChannelPicker.emailOption")), 3))
      : _createCommentVNode("", true)
  ]))
}